import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import MediaQuery from 'react-responsive';
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { ModalConsumer } from '../../Modal/ModalContext';
import RequestModal from '../../RequestModal';
import Header from '../../Header';
import { ReactComponent as ArrowIcon } from '../../../assets/img/arrow-right.svg';

import styles from './TitleScreen.module.css';
import { ASK_AN_EXPERT_LANGING_TOP } from '../../../utils/constants';

const TitleScreen = () => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles['container']}>
      <div className={styles['wrapper']}>
        <div className={`${styles['title']} Rubik-60pt`}>
          {formatMessage({id: 'TitleScreen.firstScreenTitle'})}
        </div>
        <MediaQuery minDeviceWidth={1224}>
          <div className={styles['leadership']}>
            <div className={styles['leadership_column']}>
              <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                {formatMessage({id: 'TitleScreen.firstColumnTitle'})}
              </h1>
              <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                {formatMessage({id: 'TitleScreen.firstColumnBody'})}
              </p>
            </div>
            <div className={styles['leadership_column']}>
              <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                {formatMessage({id: 'TitleScreen.secondColumnTitle'})}
              </h1>
              <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                {formatMessage({id: 'TitleScreen.secondColumnBody'})}
              </p>
            </div>
            <div className={styles['leadership_column']}>
              <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                {formatMessage({id: 'TitleScreen.thirdColumnTitle'})}
              </h1>
              <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                {formatMessage({id: 'TitleScreen.thirdColumnBody'})}
              </p>
            </div>
          </div>
        </MediaQuery>
        <MediaQuery maxDeviceWidth={1224}>
          <CarouselProvider
            totalSlides={3}
            isPlaying={true}
            interval={2000}
            naturalSlideWidth={100}
            naturalSlideHeight={50}
            infinite={true}
          >
            <Slider>
              <Slide index={0}>
                <div className={styles['leadership_column']}>
                  <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                    {formatMessage({id: 'TitleScreen.firstColumnTitle'})}
                  </h1>
                  <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                    {formatMessage({id: 'TitleScreen.firstColumnBody'})}
                  </p>
                </div>
              </Slide>
              <Slide index={1}>
                <div className={styles['leadership_column']}>
                  <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                    {formatMessage({id: 'TitleScreen.secondColumnTitle'})}
                  </h1>
                  <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                    {formatMessage({id: 'TitleScreen.secondColumnBody'})}
                  </p>
                </div>
              </Slide>
              <Slide index={2}>
                <div className={styles['leadership_column']}>
                  <h1 className={`${styles['leadership_column_title']} Rubik-26pt`}>
                    {formatMessage({id: 'TitleScreen.thirdColumnTitle'})}
                  </h1>
                  <p className={`${styles['leadership_column_body']} Rubik-20pt`}>
                    {formatMessage({id: 'TitleScreen.thirdColumnBody'})}
                  </p>
                </div>
              </Slide>
            </Slider>
          </CarouselProvider>
          <div className={styles['ask-button-container']}>
            <ModalConsumer>
              {({showModal}) => (
                <Fragment>
                  <button className={`${styles['ask-button']} Rubik-20pt`} onClick={() => showModal(RequestModal)}>
                    { formatMessage({id: 'Header.askAnExpert'}) }
                  </button>
                </Fragment>
              )}
            </ModalConsumer>
          </div>
        </MediaQuery>
        <div className={styles['links']}>
          <div className={styles['links_link']}>
            <a href="#choose-bundle">
              <ArrowIcon className={styles['link-icon']}/>
              <span className={`${styles['link-text']} Rubik-26pt`}>
                {formatMessage({id: 'TitleScreen.bundleLink'})}
              </span>
            </a>
          </div>
          <div className={styles['links_padding']}></div>
          <div className={styles['links_link']}>
            <a href="#configure-own-server">
              <ArrowIcon className={styles['link-icon']}/>
              <span className={`${styles['link-text']} Rubik-26pt`}>
                {formatMessage({id: 'TitleScreen.configureLink'})}
              </span>
            </a>
          </div>
        </div>
      </div>
      <div className={styles['header-wrapper']}>
        <Header gaValue={ASK_AN_EXPERT_LANGING_TOP}/>
      </div>
    </div>
  );
};

export default TitleScreen;
